module.exports = {
	// Overrides bold in platform
	inputStaticFontWeight: '400',
	//
	cardSpacingMargin: '0.75rem',
	//
	cardHeaderPadding: '0.75rem 0.75rem 0',
	//
	cardBodyPadding: '0 0.75rem',
	//
	cardFooterPadding: '0.5rem 0.75rem',
};
